import type { ControlActionT } from '@mentimeter/question-modules-types';
import type { SfinxTranslationFn } from '../../../state/translation';
import type { ShowMediaContext } from '../state';

export const showMedia = (
  showMediaState: ShowMediaContext,
  translate: SfinxTranslationFn,
): ControlActionT => {
  const [showMedia, setShowMedia] = showMediaState;

  const handler = () => {
    setShowMedia(!showMedia);
  };

  return {
    id: 'show-image-control',
    hotkey: 's',
    hotkeys: ['s'],
    displayControl: showMedia, // Only show control when media is showing.
    'aria-label': translate('actions.hide_image'),
    children: translate('actions.hide_image'),
    onClick: handler,
    onHotkey: handler,
    trackingAction: showMedia ? 'Hide image' : 'Show image',
  };
};
